import { render, staticRenderFns } from "./bit-performance.vue?vue&type=template&id=6daffcc2"
import script from "./bit-performance.vue?vue&type=script&lang=js"
export * from "./bit-performance.vue?vue&type=script&lang=js"
import style0 from "./bit-performance.vue?vue&type=style&index=0&id=6daffcc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports